"use client";

import React from "react";
import Autocomplete from "@/components/ui/autocomplete";
import { api } from "@/lib/trpc/client";
import { Card } from "@/components/ui/card";
import { FinancialReport } from "./FinancialReport";
import { useTranslations } from "use-intl";
import { Icon } from "@iconify/react";
const maxYear = (() => {
  const currentMonth = new Date().getMonth();
  return currentMonth < 2 ? new Date().getFullYear() - 1 : new Date().getFullYear();
})();
const startingYear = 2016;
const availableYears = Array.from({
  length: maxYear - startingYear + 1
}, (_, i) => (maxYear - i).toString());
export function FinancialReportCard({
  institutionId
}: {
  institutionId: string;
}) {
  const t = useTranslations();
  const [selectedYear, setSelectedYear] = React.useState<string>(maxYear.toString());
  const budgetData = api.budgetPublicRouter.getAllTempBudgetData.useQuery({
    institutionId
  });
  const data = budgetData.data?.find(d => (d.year ?? 0) === parseInt(selectedYear))?.data || null;
  const currentYearFinancials = {
    expenses: data?.cheltuieli.total || 0,
    income: data?.venituri.total || 0
  };
  if (budgetData.isLoading) {
    return <Card className="flex h-full items-center justify-center p-8">
        <Icon icon="svg-spinners:pulse-rings-multiple" width="48" height="48" />
      </Card>;
  }
  return <Card className="flex h-full w-full flex-col items-center justify-between overflow-hidden rounded-3xl bg-blue-700 pb-4" data-sentry-element="Card" data-sentry-component="FinancialReportCard" data-sentry-source-file="FinancialReportCard.tsx">
      <div className="flex w-full flex-col items-start">
        <div className="flex w-full flex-col items-center justify-between gap-2 space-y-1.5 rounded-t-lg p-6 desktop:flex-row">
          <div>
            <h3 className="text-2xl font-semibold leading-none tracking-tight text-white">
              {t("Your Financial Report Title")}
            </h3>
            <p className="mt-1 text-sm text-white">
              {t("revenues_vs_expenses", {
              year: selectedYear
            })}
            </p>
          </div>
          <div className="flex w-full max-w-[112px] justify-center gap-3">
            <Autocomplete placeholder={selectedYear || "An"} options={availableYears.map(year => ({
            label: year,
            value: year
          }))} initialValue={selectedYear} onChangeAction={value => setSelectedYear(String(value.value))} fullWidth data-sentry-element="Autocomplete" data-sentry-source-file="FinancialReportCard.tsx" />
          </div>
        </div>
      </div>
      <FinancialReport expenses={currentYearFinancials.expenses} income={currentYearFinancials.income} data-sentry-element="FinancialReport" data-sentry-source-file="FinancialReportCard.tsx" />
    </Card>;
}